import { render, staticRenderFns } from "./QueueCard.vue?vue&type=template&id=be471922&scoped=true"
import script from "./QueueCard.vue?vue&type=script&lang=js"
export * from "./QueueCard.vue?vue&type=script&lang=js"
import style0 from "./QueueCard.vue?vue&type=style&index=0&id=be471922&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be471922",
  null
  
)

export default component.exports